/**
 * Created by calhosh on 9/13/2024
 */
import {useEngagementId, useUserPreferences, useWhyDidYouUpdate} from '../../../util/customhooks';
import {useDispatch, useSelector} from 'react-redux';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import env from '../../../util/env';
import Utility from '../../../util/utilityfunctions';
import {MotifNav, toggleFrameModal, frameEvents} from '@ey/canvascoreservices';
import TeamsUserInfo from '@ey/canvascoreservices-teams';
import RemoteComponent from '../ModuleFederation/RemoteComponent';
import envConfig from '@ey/voltron-config';
import {NotificationPlaceholder} from '../ModuleFederation/NotificationPlaceholder';
import {getBookmarkAction} from '../../../actions/Task/updateTaskaction';
import {
	ENGAGEMENTMETADATA_URL,
	EngagementStatus,
	IndependenceStatus,
	NavConfig,
	serviceURL,
	userType
} from '../../../util/uiconstants';
import {getEngagement, getEngagementProfileData} from '../../../actions/Engagement/engagementactions';
import {getDocumentServiceConfiguration} from '../../../actions/ClientRequest/ClientRequestDocuments/clientRequestDocumentsActions';
import {raiseJSValidationError} from '../../../actions/erroractions';
import {getQuickLinks} from '../../../actions/Milestone/QuickLinks/quicklinksactions';
import {getEngagementMetaData, getEngagementUsersWithRoles} from '../../../actions/Engagement/engagementactions';
import MotifMenuOptions from '../Nav/MotifMenuOptions';
import {MenuIconOptions} from './NavUtils';
import {labels} from '../../../util/utils';
import * as UIFilterActions from '../../../actions/Engagement/uifilteractions';
import {getConfigurations} from '../../../actions/Configuration/configurationsaction';
import Label from '@ey/motif-react-wrapper/Label';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import {getIsAutomationHubEnabled} from '../../../reducers/globalstatereducer';
import styled from 'styled-components';
import {useHistory, useLocation} from 'react-router-dom';
import AIChatbot from '../AIChatbot/AIChatbot';
import {setAIChatBotIntegrationParameters} from '../../../actions/IntegrationParameters/aichatbotintegrationparametersactions';

export default function TopBarNav() {
	const searchVariant = {
		control: 'select',
		options: ['expansible', 'overlap', 'fixed']
	};
	const [personData, setPersonData] = useState(undefined);
	const [baseCanvasUrl, setBaseCanvasUrl] = useState('');
	const mode = Utility.getTheme();
	const engagementId = useEngagementId();
	const aiChatBotContext = useSelector((state) => state.aiChatBotIntegrationParameters);
	const engagement = useSelector((store) => store.engagement);
	const offlinePrep = useSelector((store) => store.offlinePrep);
	const configurations = useSelector((store) => store.configurations);
	const quickLink = useSelector((store) => store.quickLink);
	const apponlinestate = useSelector((store) => store.apponlinestate);
	const connectivitystate = useSelector((store) => store.connectivitystate);
	const isAutomationHubEnabled = useSelector((store) => getIsAutomationHubEnabled(store));
	const globalNavState = useSelector((store) => store.globalNavState);
	const user = useUserPreferences();
	const dashboardDomain = env.getURL('hercules_web');
	const zeusUrl = env.getURL('Zeus_web');
	const engagementMetaData = useSelector((store) => store.engagementMetaData);
	const [defaultSelectedEngagement, setDefaultSelectedEngagement] = useState(undefined);
	const [configurationIsLoaded, setConfigurationIsLoaded] = useState(false);
	const [iconOptions, setIconOptions] = useState([]);
	const [gateWayOptionsOpen, setGateWayOptionsOpen] = useState(false);
	const [selectedIcon, setSelectedIcon] = useState(undefined);
	const [showAIChatbot, setShowAIChatbot] = useState(false);
	const [showChatbotIcon, setShowChatbotIcon] = useState(false);
	const [engagementDropdownOptions, setEngagementDropdownOptions] = useState([]);
	const history = useHistory();
	const location = useLocation();
	const isLocalLandingPage = useMemo(() => {
		return window.location.pathname.toLowerCase().includes('/locallandingpage');
	}, [window.location.pathname]);
	const taskDetails = useSelector((state) => state.taskDetails);
	const dispatch = useDispatch();

	useEffect(() => {
		if (user) {
			setPersonData({
				person: {
					firstName: user.firstName,
					lastName: user.lastName,
					emailAddress: user.emailAddress,
					viewType: 'avatar'
				}
			});
		}
	}, [user]);

	const handleButtonClick = (url, icon) => {
		history.push(url);
		setSelectedIcon(icon);
		toggleFrameModal({frameArgs: {event: frameEvents.TOGGLE_DRAWER, open: false}});
	};

	useEffect(() => {
		if (globalNavState?.refreshActiveIcon) {
			const {pathname, search} = location;
			const icons = NavConfig.filter(
				({url, qString}) => pathname?.toLowerCase()?.includes(url) && (!qString || search?.includes(qString))
			);
			setSelectedIcon(icons.pop()?.icon);
		}
	}, [globalNavState]);

	useEffect(() => {
		if (!NavConfig.find((nav) => location.pathname.indexOf(nav.url) !== -1)?.icon) {
			setSelectedIcon(null);
		}
	}, [location]);

	useEffect(() => {
		if (taskDetails && taskDetails.taskId) {
			const payload = {
				pageDetails: {
					pageUrl: window.location.href,
					knowledgeTaskId: taskDetails.cgTaskId ?? 0,
					knowledgeFormId: 0
				}
			};

			// condition is added so that we don't set the same payload again and again in the store,
			// currently task detail state set even if we related some document to refresh task detail state
			if (
				payload.pageDetails.knowledgeTaskId != aiChatBotContext?.pageDetails?.knowledgeTaskId ||
				payload.pageDetails.knowledgeFormId != aiChatBotContext?.pageDetails?.knowledgeFormId
			) {
				dispatch(setAIChatBotIntegrationParameters(payload));
			}
		}
	}, [taskDetails]);

	useEffect(() => {
		let result = [];
		if (engagementMetaData && engagementMetaData?.length > 0 && !defaultSelectedEngagement) {
			engagementMetaData.map((eng) => {
				const status = eng.engagementstatusid,
					indstatus = eng.independencestatusid;
				if (
					status === EngagementStatus.Active ||
					status === EngagementStatus.Restored ||
					status === EngagementStatus.MarkedForDeletion ||
					status === EngagementStatus.CanvasExternalAccessPortalV2
				) {
					if (
						indstatus === IndependenceStatus.NoMattersIdentified ||
						indstatus === IndependenceStatus.MatterResolvedGrantedAccess ||
						indstatus === IndependenceStatus.NotApplicable
					) {
						const displayedEngagement = {
							value: eng.engagementid,
							label: eng.engagementdescription + ' ' + eng.clientname,
							title: eng.engagementdescription + ' ' + eng.clientname,
							clientname: eng.clientname,
							engdesc: eng.engagementdescription,
							engUrl:
								(dashboardDomain === undefined ? window.location.origin : dashboardDomain) +
								/*window.location.pathname +*/
								'?engagementid=' +
								eng.engagementid
						};
						if (engagement?.engagementId === Number(eng.engagementid)) {
							setDefaultSelectedEngagement([displayedEngagement]);
						} else {
							result.push(displayedEngagement);
						}
					}
				}
			});
			setEngagementDropdownOptions(result);
		}
	}, [engagementMetaData]);

	const engagementIsLoading = _.isEmpty(engagement);

	const engagementOptionLabel = ({title, clientname, engdesc, engUrl}) => (
		<a href={engUrl}>
			<section title={title} className="selectOption">
				<section className="selectText">{clientname}</section>
				<section className="engName">{engdesc}</section>
			</section>
		</a>
	);

	const engagementSelectorRender = () => {
		if (!engagementMetaData || engagementMetaData.length === 0) {
			return <Label>{engagement !== undefined && engagement.id ? engagement.engagementDescription : ''}</Label>;
		} else {
			return (
				<section className={'EYEngagementDropdown ' + (engagementMetaData ? '' : 'hide')}>
					<StyledEngagementSelect
						className="EYEngagementDropdownSelect"
						placeholder="Select Engagement"
						id="RelatedEngagements"
						noOptionsMessage={() => labels.noResultsFoundLabel}
						isClearable={false}
						options={engagementDropdownOptions}
						value={defaultSelectedEngagement}
						defaultValue={defaultSelectedEngagement}
						formatOptionLabel={engagementOptionLabel}
						isDisabled={!apponlinestate}
					/>
				</section>
			);
		}
	};

	useEffect(() => {
		let iconOptions = [];
		if (configurationIsLoaded && engagement?.engagementId && quickLink?.engagementId && configurations?.features) {
			iconOptions = MenuIconOptions({
				engagement: engagement,
				configurations: configurations,
				engagements: engagementMetaData,
				displayLanguage: user?.displayLanguage,
				isAutomationHubEnabled: isAutomationHubEnabled,
				gateWayOptionsOpen: gateWayOptionsOpen,
				setGateWayOptionsOpen: setGateWayOptionsOpen,
				selectedIcon: selectedIcon,
				setSelectedIcon: setSelectedIcon,
				handleButtonClick: handleButtonClick,
				quickLinks: quickLink
			});
		}
		setIconOptions(iconOptions);
		setShowChatbotIcon(configurations.features?.isOrchestratorEnabled);
	}, [engagement, configurations, quickLink, configurationIsLoaded, selectedIcon]);

	const teamsAvatarRender = () => {
		return <TeamsUserInfo personData={personData} personCardInteraction={'none'} theme={mode} />;
	};

	const handleSettingsClick = () => {
		window.open(zeusUrl + `/usersettings?referrer=${new URL(window.location.href)}`, '_self');
	};

	const notificationRender = () => {
		return (
			<>
				{configurations && configurations.features && configurations.features.enableNotifications ? (
					<div className="notifications-icon-wrapper">
						<RemoteComponent
							key="notifications"
							id="notifications"
							adConfig={envConfig.ad}
							engagementId={engagement.engagementId}
							darkHeader
							showDummyTriggerButton={false}
							newBaseFontSize={true}
							displayLanguage={user?.displayLanguage}
							darkMode={mode}
							numberFormat={user?.numberFormat}
							liveNotificationDelayInSeconds={configurations.features?.liveNotificationDelayInSeconds}
							loadingFallback={
								<NotificationPlaceholder
									notificationMessage={labels.notificationUpbutSomeLoadingErrorMessage}
									mode={mode}
								/>
							}
							errorFallback={
								<NotificationPlaceholder notificationMessage={labels.notificationDownErrorMessage} mode={mode} />
							}
						/>
						<NotificationPlaceholder
							notificationMessage={labels.notificationUpbutSomeLoadingErrorMessage}
							mode={mode}
						/>
					</div>
				) : (
					<></>
				)}
			</>
		);
	};

	const getBookMarks = () => {
		if (engagement && engagement.engagementId) {
			dispatch(
				getBookmarkAction(
					env.getBaseURL(serviceURL, engagement.engagementId) + 'Tasks?bookmark=true',
					env.getBaseURL(serviceURL, engagement.engagementId),
					engagement.workspaceId
				)
			);
		}
	};

	const isArchiveEngagement = () => {
		return engagement?.engagementStatusId !== undefined && engagement.engagementStatusId === EngagementStatus.Archived;
	};

	const getFilters = () => {
		if (engagementId) {
			const url = env.getServerUrl('Engagements/' + engagementId + '/filters');
			dispatch(UIFilterActions.getUIFilters(url));
		}
	};

	const getEngagementUsersAndRoles = (engagementId) => {
		if (engagementId) {
			const usersUrl = `${env.getBaseURL(serviceURL, engagementId)}Users?userType=${
				userType.UserSummary
			}&engagementId=${engagementId}`;
			dispatch(getEngagementUsersWithRoles(usersUrl));
		}
	};

	const getEngagementInformation = () => {
		if (engagementId === '' || !Number(engagementId) || Number(engagementId) <= 0) {
			dispatch(raiseJSValidationError(labels.invalidEngagementId));
			return;
		}

		getEngagementUsersAndRoles(engagementId);
		dispatch(getEngagement(env.getServerUrl('Engagements/' + engagementId + '?IncludeEngagementMetaData=true')));
	};

	const getEngagementQuickLinks = () => {
		return dispatch(getQuickLinks(env.getBaseURL(serviceURL, Number(engagementId)) + 'QuickLinks'))
			.then(() => {
				let curl = Utility.getCanvasBaseUrl(engagement, user?.displayLanguage);
				setBaseCanvasUrl(curl);
			})
			.catch((result) => {
				if (result && result.response && result.response.status === 403) {
					dispatch(raiseJSValidationError(labels.invalidEngagementId));
				}
			});
	};

	const getConfigurationFeatures = () => {
		let configurationUrl = env.getBaseURL(serviceURL) + 'FeatureConfigurations';
		return dispatch(getConfigurations(configurationUrl));
	};

	const getEngagementProfileDetails = () => {
		if (engagementId === '' || !Number(engagementId) || Number(engagementId) <= 0) {
			dispatch(raiseJSValidationError(labels.invalidEngagementId));
			return;
		}

		dispatch(getEngagementProfileData(env.getBaseURL(serviceURL, Number(engagementId)) + 'Profile'));
	};

	const getEngagementMetaDataCall = () => {
		if (user && user.id && !user.isGuestUser) {
			if (!engagementMetaData || !engagementMetaData.totalpageditems) {
				const engagementId = Utility.getEngagementIdFromUrl(window);

				/*when multiple datacenters are allowed we will set showdatacenterengagementsonly eq false and will have to
				change the url creation above in bindEngagementOptions*/
				return dispatch(
					getEngagementMetaData(
						env.getUniversalUrl(
							`${ENGAGEMENTMETADATA_URL}?filters=engagementid eq ${engagementId},showdatacenterengagementsonly eq true,
							showaccessibleengagementsonly eq true, engagementstatusid eq '${EngagementStatus.Active},
							${EngagementStatus.Restored},
							${EngagementStatus.MarkedForDeletion},
							${EngagementStatus.CanvasExternalAccessPortalV2}'`
						)
					)
				);
			}
		}
	};

	const getDocumentServiceConfigurations = () => {
		if (user && user.id) {
			dispatch(getDocumentServiceConfiguration(engagementId));
		}
	};

	useEffect(() => {
		const getEngagementData = () => {
			if (engagement.engagementId) {
				document.title = engagement.engagementDescription;
				let curl = Utility.getCanvasBaseUrl(engagement, user?.displayLanguage);
				setBaseCanvasUrl(curl);
			}
		};

		getEngagementData();
	}, [engagement, configurationIsLoaded]);

	useEffect(() => {
		getEngagementMetaDataCall();
		// this is call for document service configuration
		getDocumentServiceConfigurations();
	}, [user]);

	useEffect(() => {
		if (!isLocalLandingPage) {
			Promise.allSettled([
				getFilters(),
				getConfigurationFeatures(),
				getEngagementInformation(),
				getEngagementProfileDetails(),
				getEngagementQuickLinks()
			]).then(() => {
				setConfigurationIsLoaded(true);
			});
		}

		const payload = {
			pageDetails: {
				pageUrl: window.location.href,
				knowledgeTaskId: 0,
				knowledgeFormId: 0
			}
		};
		dispatch(setAIChatBotIntegrationParameters(payload));
	}, []);

	return (
		<StyledMotifNavWrapper className="StyledMotifNavWrapper motif-no-padding">
			<MotifNav
				applicationName={labels.canvas}
				applicationNameRedirectUrl={zeusUrl}
				disableLogo={false}
				loading={engagementIsLoading}
				copyrightMessage={labels.copyrightMessage}
				showIconLinks
				hideOffline={false}
				apponlinestate={apponlinestate}
				connectivitystate={connectivitystate}
				topNavLinks={iconOptions}
				showMoreMenuOptions={!isLocalLandingPage}
				showSelectorDropdown
				selectorDropdown={engagementSelectorRender}
				showNotifications={configurations && configurations.features && configurations.features.enableNotifications}
				notifications={notificationRender}
				showSettings={false}
				showSearchBox={false}
				settingsOnClick={handleSettingsClick}
				showAvatar
				teamsAvatar={teamsAvatarRender}
				workOfflineLabel={labels.workoffline}
				workOnlineLabel={labels.workonline}
				workOfflineMessage={labels.workofflinemsg}
				workOnlineMessage={labels.workonlinemsg}
				showAIChatbot={!isArchiveEngagement()}
				aiChatbotOnclick={() => {
					setShowAIChatbot(!showAIChatbot);
				}}
				chatbotTitle={labels.aiChatbot}
				offlinePrep={offlinePrep}
				getBookmarkAction={getBookMarks}
			>
				<MotifMenuOptions
					quickLinks={quickLink}
					baseCanvasUrl={baseCanvasUrl}
					isOfflineMode={!apponlinestate}
					engagementId={engagement.engagementId}
					engagementDescription={engagement.engagementDescription}
					gaRoleTypeId={engagement.gaRoleTypeId}
					featureConfigurations={configurations}
					engagement={engagement}
				/>
			</MotifNav>

			<StyledChatBoxWrapper className={'chatbot-wrapper'}>
				{engagement?.engagementStatusId !== undefined && engagement.engagementStatusId !== EngagementStatus.Archived ? (
					<AIChatbot setShow={setShowAIChatbot} show={showAIChatbot} />
				) : (
					<></>
				)}
			</StyledChatBoxWrapper>
		</StyledMotifNavWrapper>
	);
}

TopBarNav.displayName = 'TopBarNav';

const StyledMotifNavWrapper = styled.section`
	.motif-dropdown {
		&.GateWayOptionsDropdown {
			.motif-dropdown-menu {
				gap: var(--spacing-small);
				.ChildSection {
					&:hover {
						background-color: var(--neutrals-50);
						cursor: pointer;
					}
					a {
						color: var(--neutrals-900);
						font-size: var(--px-16);
						font-weight: 300;
						line-height: var(--px-24);
						width: 100%;
						padding: var(--spacing-medium-small) var(--spacing-medium-large);
						&:hover,
						&:focus,
						&:active,
						& {
							color: var(--neutrals-900);
							text-decoration: none;
							border: 0;
						}
						.motif-icon {
							display: inline-flex;
							svg {
								width: 1.2rem;
								height: 1.2rem;
								margin-top: 0 !important;
							}
						}
						.SpanLableTxt {
							display: inline-flex;
							align-items: center;
							font-size: var(--px-14);
							font-weight: 300;
							color: var(--neutrals-900);
						}
					}
				}
			}
		}
	}
`;

const StyledChatBoxWrapper = styled.section``;

const StyledEngagementSelect = styled(ReactSelect)`
	z-index: 999;
`;
